import { format } from "date-fns";

export function dateToClintFormat(data: string): string {
  return format(data, "dd.MM.yyyy");
}

export function dateToClintFullDateFormat(data: string): string {
  return format(data, "dd.MM.yyyy HH:mm");
}

export function dateToClintShortDateTimeFormat(data: string): string {
  return format(data, "dd.MM.yy HH:mm");
}

export function dateToClintTimeFormat(data: string): string {
  return format(data, "HH:mm");
}

export const dateToFullFormatFrombBack = (dateStr: string): string => {
  const [datePart, timePart] = dateStr.split(/[T+]/); // делим до "+06:00"

  const [year, month, day] = datePart.split("-");
  const [hour, minute] = timePart.split(":");

  return `${day}.${month}.${year} ${hour}:${minute}`;
};
